import { render, staticRenderFns } from "./ArticleMeta.vue?vue&type=template&id=22bb3cfd&"
import script from "./ArticleMeta.vue?vue&type=script&lang=ts&"
export * from "./ArticleMeta.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports